import styles from './VServicesModalRecycleDetails.module.css'

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from "../../../../../../customHooks/useScrollBlock";
import PopupAppearLayout from "../../../../common/Modals/Layouts/PopupAppearLayout";
// 
import image from './image.jpg'

const VServicesModalRecycleDetails = () => {

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const closeModal = () => {
      // setTimeout(function(){allowScroll()}, 150);
      allowScroll()
      modal.close()
    } 
    
    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            <div className={styles.container}>

                
                {/* HEADER */}
                <div className={styles.header_container}>
                    <div className={styles.header_title}>
                        <p>Реализация вторичного сырья</p>
                    </div>
                    
                    <button
                        className={styles.popup_layout__close}
                        type="button"
                        onClick={closeModal}
                        aria-label="Закрыть"
                    >
                        &#9587;
                    </button>
                </div>
                
                {/* CONTENT */}
                <div className={styles.content__container}>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Сбор и отправка вторичного сырья для переработки
                        </div>
                        <div className={styles.text}>
                            Наша компания предоставляет услуги по сбору и отправке вторичного сырья для дальнейшей переработки. Мы занимаемся эффективным сбором различных видов вторичных материалов, включая пластик, стекло, бумагу и металлы, и обеспечиваем их перевозку на соответствующие перерабатывающие предприятия. Наша цель - содействовать устойчивому использованию ресурсов и охране окружающей среды, обеспечивая эффективное использование вторичных материалов в производственных цепочках.
                        </div>
                    </div>

                    <div className={styles.imageBlock}>
                        <img className={styles.image} src={image} alt="Доставка воды" />
                    </div>

                    {/* buttons */}
                    <div className={styles.btnBlock}>
                        <button
                            className={styles.btn_return}
                            type="button"
                            onClick={closeModal}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>

            </div>
        </PopupAppearLayout>
    );   
}

export default VServicesModalRecycleDetails;